import { forIn, forEach, isFunction, isEmpty, isArray, head } from 'lodash';
import validator from 'validator';

const fieldValidate = (form, value, fieldConstrains) => {
  if (isFunction(fieldConstrains)) {
    const result = fieldConstrains(value, form);
    if (isFunction(result) || isArray(result)) {
      return fieldValidate(form, value, result);
    }
    return result;
  } else if (isArray(fieldConstrains)) {
    const fieldErrors = [];
    forEach(fieldConstrains, fieldConstrain => {
      const error = fieldConstrain(value, form);
      if (error) {
        fieldErrors.push(error);
      }
    });
    if (!isEmpty(fieldErrors)) {
      return head(fieldErrors);
    }
  }
  return null;
};

export const validate = (form = {}, constrains = {}) => {
  const errors = {};
  forIn(form, (value, key) => {
    const fieldConstrains = constrains[key];
    const error = fieldValidate(form, value, fieldConstrains);
    if (error) {
      errors[key] = error;
    }
  });
  return isEmpty(errors) ? null : errors;
};

export const validationRules = {
  required: (value) => {
    if (!value) {
      return 'Can\'t be blank.';
    }
    return null;
  },
  email: (value) => {
    if (value && !validator.isEmail(value.trim())) {
      return 'Not a valid email.';
    }
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/utils/validationUtils.js